import type { XY } from "../xy";
import { Timing } from "./effect";
import { XYEffect } from "./xyEffect";

export class Explosion extends XYEffect {
	static key = "Explosion";
	constructor(xy: XY) {
		super(xy);
		this.setTiming(Timing.BEFORE_STATE_UPDATE);
	}
}
